import { layout } from '../../App.routing'

export const coronavirusSegment = layout.component({
    type: 'uniform',
    props: {
        section: 'news',
        verticalSpacing: 'xl',
        cardOrientation: { type: 'Landscape-Portrait' },

        cardLayout: [
            ['teaserWithBackground'],
            ['teaserWithBackground'],
            ['teaserWithBackground'],
            {
                type: 'november',
                listLength: 5,
                hasTimestamp: true,
            },
        ],
        sectionHeader: {
            heading: 'Coronavirus (COVID-19)',
            headingUrl: '/news/coronavirus',
        },
        dataDefinitionArgs: {
            type: 'curation',
            name: 'coronavirus',
            offset: 0,
            pageSize: 8,
        },
    },
})
